"use client"

import { createContext, useContext, type ReactNode } from "react"

interface DynamicFormLabelContextValue {
	namespace: string
	hideRequiredMark: boolean
}

const DynamicFormLabelContext = createContext<DynamicFormLabelContextValue>({
	namespace: "creagen-components",
	hideRequiredMark: false
})

export function useDynamicFormLabelContext(): DynamicFormLabelContextValue {
	return useContext(DynamicFormLabelContext)
}

interface DynamicFormLabelProviderProps {
	namespace: string
	hideRequiredMark?: boolean
	children: ReactNode
}

export function DynamicFormLabelProvider({ namespace, hideRequiredMark = false, children }: DynamicFormLabelProviderProps) {
	return <DynamicFormLabelContext value={{ namespace, hideRequiredMark }}>{children}</DynamicFormLabelContext>
}
